const AUTH = {
  ASSIGN_FACTORING_RISK_EVALUATOR: 'auth.assign_factoring_risk_evaluator',
  COLLECTION: 'auth.collection',
};

const BACKOFFICE_RISK = {
  ADD_COMPANIES_TO_RISK_LIST: 'backoffice_risk.add_risklist',
  CHANGE_RISK_LIST: 'backoffice_risk.change_risklist',
  ADD_RISK_EVALUATION_MODEL: 'backoffice_risk.add_riskevaluationmodel',
};

const BANKING = {
  ADD_BANK_MOVEMENT: 'banking.add_bankmovement',
  ADD_CONCILIATED_MOVEMENT: 'banking.add_conciliatedmovement',
  ADD_NON_OPERATIVE_MOVEMENT: 'banking.add_nonoperativemovement',
};

const BUREAUS = {
  CHANGE_DICOM: 'bureaus.change_dicom',
  VIEW_DICOM: 'bureaus.view_dicom',
};

const COMMERCIAL = {
  VIEW_CUSTOMERS_PORTFOLIO: 'auth.view_commercial_customers_portfolio',
  VIEW_PIPELINE_MANAGER: 'auth.view_commercial_pipeline_manager',
  VIEW_CESSION_PREDICTIONS: 'auth.view_commercial_cession_predictions',
  EXPORT_CUSTOMERS_PORTFOLIO: 'auth.export_commercial_customers_portfolio',
  EXPORT_CESSION_PREDICTIONS: 'auth.export_commercial_cession_predictions',
};

const COLLECTION = {
  ADD_COLLECTION_ACTION: 'collection.add_collectionaction',
  ADD_COLLECTION_MAIL: 'collection.add_collectionmail',
  ADD_DATA_FOR_COLLECTION: 'collection.add_dataforcollection',
  ADD_REINTEGRATION: 'collection.add_reintegration',
  ADD_REPLACEMENT: 'collection.add_replacement',
  USE_SURPLUS_FOR_DIFFERENCE: 'collection.use_surplus_for_difference',
};

const CUSTOMERS = {
  ADD_COMPANYFRAMEWORKCONTRACTREQUEST: 'customers.add_companyframeworkcontractrequest',
  ADD_COMPANYFRAMEWORKCONTRACTREGISTER: 'customers.add_companyframeworkcontractregister',
  ADD_COMPANY_RESTRICTION: 'customers.add_companyevaluationrestrictions',
  ADD_CREDIT_LINE_INFO: 'customers.add_creditlineinfo',
  ADD_TERM_WHITELIST: 'customers.add_termwhitelist',
  APPROVE_COMPANY_EVALUATION_RESTRICTION: 'customers.approve_companyevaluationrestrictions',
  CHANGE_COMMISSION_RULE: 'customers.change_commissionrule',
  CHANGE_COMPANY_RESTRICTION: 'customers.change_companyevaluationrestrictions',
  CHANGE_CREDIT_LINE_INFO: 'customers.change_creditlineinfo',
  CHANGE_TERM_WHITELIST: 'customers.change_termwhitelist',
};

const EVALUATION_REQUESTS = {
  ADD_CREDITLINE_EVALUATION_REQUEST: 'evaluation_requests.add_creditlineevaluationrequest',
  CAN_SKIP_PREOFFER_ASSIGNED_EVALUATOR_VALIDATION: 'evaluation_requests.can_skip_preoffer_assigned_evaluator_validation',
  CHANGE_PREOFFER_EVALUATION_REQUEST: 'evaluation_requests.change_preofferevaluationrequest',
  CHANGE_CREDITLINE_EVALUATION_REQUEST: 'evaluation_requests.change_creditlineevaluationrequest',
};

const FUNDING = {
  UPLOAD_PAYROLL_CONCILIATION_FILE: 'funding.upload_payroll_conciliation_file',
  UPLOAD_PUERTO_X_FILE: 'funding.upload_puerto_x_file',
};

const INVOICES = {
  ADD_PRICING_BUSINESS_RATE: 'invoices.add_pricingbusinessrate',
  CHANGE_RATE_WHITELIST: 'invoices.change_ratewhitelist',
  CHANGE_REVIEW_DOCUMENTS_MANAGER: 'invoices.change_reviewdocumentsmanager',
};

const MONEY_TRANSFER = {
  ADD_TREASURY_MESSAGE: 'money_transfer.add_treasurymessage',
  CHANGE_INVOICE_LOAN_MONEY_TRANSFER: 'money_transfer.change_invoiceloanmoneytransfer',
  CHANGE_INVOICE_MONEY_TRANSFER: 'money_transfer.change_invoicemoneytransfer',
  MAKE_MANUAL_MONEY_TRANSFER: 'money_transfer.make_manual_money_transfer',
};

const ORDERING = {
  CHANGE_ORDERING_SIMULATION_EVALUATION_REQUEST: 'ordering.change_orderingsimulationevaluationrequest',
};

const PRICING = {
  CHANGE_PRICING_RANGE: 'pricing.change_pricingrange',
  CHANGE_PRICING_RULE_SET: 'pricing.change_pricingruleset',
};

export {
  AUTH,
  BACKOFFICE_RISK,
  BANKING,
  BUREAUS,
  COMMERCIAL,
  COLLECTION,
  CUSTOMERS,
  EVALUATION_REQUESTS,
  FUNDING,
  INVOICES,
  MONEY_TRANSFER,
  ORDERING,
  PRICING,
};
